import { service } from "@ember/service";
import DiscourseRoute from "discourse/routes/discourse";

export default class CircleActivityIndexRoute extends DiscourseRoute {
  @service router;

  beforeModel(transition) {
    if (transition.urlMethod === "replace") {
      this.router.replaceWith("circle.activity.topics");
    } else {
      this.router.transitionTo("circle.activity.topics");
    }
  }
}
